<template>
  <div class="container" v-if="success">
    <a-spin :spinning="loading">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <strong>
            <label for="state">Seleccione su reporte :</label>
          </strong>
          <div class="d-table-cell w-100">
            <v-select 
              v-model="report"
              :clearable= "false"
              :options="reports"
            >
              <template slot="option" slot-scope="option">
                <div class="d-center">
                  {{ option.label }}
                </div>
              </template>
            </v-select>
          </div>
          <div class="d-table-cell align-middle">
            <b-button :disabled="report === null ? true : false" @click="getReport" class="ml-1" size="sm" style="height: 2.5em;">
              <i class="fa fa-search"></i>
            </b-button>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <fieldset class="col-sm-12 col-md-12 col-lg-12 col-xl-12 p-2">
          <legend>Filtros:</legend>
          <div class="row my-2">
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <b-form-group label-for="aduana" :invalid-feedback="errors.first('aduana')" :state="!errors.has('aduana')">
                <v-select
                  label="text"
                  v-model="aduana" 
                  :options="aduanas"
                  :reduce="aduana => aduana.id"
                  :state="errors.has('aduana') ? false : null"
                  placeholder=" Aduanas.."
                  :disabled="disabledAduana"
                ></v-select>
              </b-form-group>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
              <v-select
                v-model="gestion"
                label="text"
                :options="gestiones"
                :reduce="gestion => gestion.id"
                placeholder=" Gestión.."
              ></v-select>
            </div>
          </div>
        </fieldset>
      </div>
      <div v-if="chartOptions">
        <highcharts :options="chartOptions"></highcharts>
      </div>
      <div v-if="report && chartOptions2">
        <highcharts :options="chartOptions2"></highcharts>
      </div>
    </a-spin>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import {Chart} from 'highcharts-vue'
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import "vue-custom-scrollbar/dist/vueScrollbar.css"
  import formatter from '../../mixins/formatter'
  import locale from 'ant-design-vue/es/date-picker/locale/es_ES'
  import moment from 'moment'
  import 'moment/locale/es'
  import OfficeService from '../../services/office.service'
  import ReportService from '../../services/report.service'
  import CustomerService from '../../services/customer.service'
  import UserService from '../../services/user.service'
  import AduanaService from '../../services/aduana.service'
  import TableAccountCustomer from '../../components/widgets/Tables/TableAccountCustomer.vue'

  export default {
    mixins: [formatter],

    data() {
      return {
        success: false,
        loading: false,
        locale,
        moment,
        report: null,
        reports: [
          { label: 'Total Trámites Por Canal', value: 'reportes/canal/grafico', type: 1 },
          { label: 'Trámites Por Gestión', value: 'reportes/gestion/grafico', type: 2},
        ],
        aduana: null,
        aduanas: [],
        gestion: null,
        gestiones: [
          {id: 2014, text: 'Gestion 2014'},
          {id: 2015, text: 'Gestion 2015'},
          {id: 2016, text: 'Gestion 2016'},
          {id: 2017, text: 'Gestion 2017'},
          {id: 2018, text: 'Gestion 2018'},
          {id: 2019, text: 'Gestion 2019'},
          {id: 2020, text: 'Gestion 2020'},
          {id: 2021, text: 'Gestion 2021'},
          {id: 2022, text: 'Gestion 2022'},
        ],
        dateFormat: 'YYYY/MM/DD',
        date: null,
        disabledAduana: false,
        chartOptions: null,
        // chartOptions2: 
      }
    },

    components: {
      'table-account-customer': TableAccountCustomer,
      vueCustomScrollbar,
      ...mapGetters([
        'currentUser'
      ]),
      highcharts: Chart,
    },

    watch: {
      report: function (value) {
        this.chartOptions = null
        this.chartOptions2 = null
        this.aduana = null
        this.gestion = null
      },
    },

    computed: {
      ...mapGetters([
        'currentUser'
      ])
    },

    created() {
      Promise.all([this.listAduanas()])
      .then(() =>{
        this.success = true
        this.$emit("graphic", false)
      })
    },

    methods: {
      listAduanas: async function() {
        const reponse = await AduanaService.listAduanas();
        if (reponse.status === 200) {
          this.aduanas = reponse.data
        }
      },

      selectColors(numColors, colorPalette) {
        const selectedColors = [];

        for (let i = 0; i < numColors; i++) {
          const colorIndex = i % colorPalette.length;
          selectedColors.push(colorPalette[colorIndex]);
        }

        return selectedColors;
      },

      setOptionChart1(data) {
        const newArray = data.slice(0, 3)
        const dataKeys = newArray.map(item => Object.keys(item.data))
        const categories = Array.from(new Set(dataKeys.flat()))
        const series = data.map(item => ({
          ...item,
          data: Object.values(item.data)
        }));

        this.chartOptions = {
          responsive: {  
            rules: [{  
              condition: {  
                maxWidth: 200  
              },  
              chartOptions: {  
                legend: {  
                  enabled: false  
                }  
              }  
            }]  
          },
          title: {
            text: 'Total Trámites Por Canal y Aduanas',
            align: 'center'
          },
          xAxis: {
            categories: categories,
            // tickInterval: 1
          },
          yAxis: {
            title: {
              text: 'Carpetas'
            },
            // tickInterval: 1
          },
          tooltip: {
            valueSuffix: ' carpetas'
          },
          series: series
        }
      },

      setOptionChart2(data) {

        let dataEncontrados = {};

        data.forEach(function(item) {
          for (var key in item.data) {
            if (dataEncontrados[key]) {
              dataEncontrados[key] += item.data[key]
            } else {
              dataEncontrados[key] = item.data[key]
            }
          }
        })

        let categories = Object.keys(dataEncontrados).map(function(key) {
          return key + ' <span class="f16"><span id="flag" class="flag no"></span></span>'
        })

        let series = data.map(function(item) {
          let newData = Object.values(item.data)
          item.data = newData
          return item
        })

        const series2 = series.map(item => ({
          name: item.name.toString(),
          y: Object.values(item.data).reduce((acc, value) => acc + value, 0)
        }))

        let numElements = series.length

        const colorPalette  = ['#004443', '#00755c', '#00c16c', '#90ff17', '#90ff17', '#23c06f', '#5ad093', '#91e0b7', '#c8efdb', '#ffffff']

        let colors = this.selectColors(numElements, colorPalette)

        this.chartOptions = {
          responsive: {  
            rules: [{  
              condition: {  
                maxWidth: 200  
              },  
              chartOptions: {  
                legend: {  
                  enabled: false  
                }  
              }  
            }]  
          },
          colors: colors,
          chart: {
            type: 'bar',
            inverted: true,
            polar: true
          },
          title: {
            text: '<b>Total De Trámites Por Aduana y Gestión</b>',
            align: 'center'
          },
          tooltip: {
            outside: true
          },
          pane: {
            size: '85%',
            innerSize: '20%',
            endAngle: 270
          },
          xAxis: {
            tickInterval: 1,
            labels: {
              align: 'right',
              useHTML: true,
              allowOverlap: true,
              step: 1,
              y: 3,
              style: {
                fontSize: '13px'
              }
            },
            lineWidth: 0,
            categories: categories
          },
          yAxis: {
            title: {
              text: 'Total Carpetas'
            },
            crosshair: {
              enabled: true,
              color: '#333'
            },
            lineWidth: 0,
            tickInterval: 20,
            reversedStacks: false,
            endOnTick: true,
            showLastLabel: true
          },
          plotOptions: {
            column: {
              stacking: 'normal',
              borderWidth: 0,
              pointPadding: 0,
              groupPadding: 0.15
            }
          },
          series: series
        }

        this.chartOptions2 = {
          colors: colors,
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {
            text: '<b><u>Gestiones</u></b>',
            align: 'left'
          },
          tooltip: {
            outside: true
          },
          accessibility: {
            point: {
              valueSuffix: '%'
            }
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y} Trámites'
              }
            }
          },
          series: [{
              name: 'Carpetas',
              colorByPoint: true,
              data: series2
          }]
        }
      },

      getReport: async function() {
        this.loading = true
        this.chartOptions = null
        this.chartOptions2 = null
        try {
          let config = {
            method: 'post',
            url: this.report.value,
            data: {
              aduana: this.aduana,
              gestion: this.gestion
            }
          }
          const response = await ReportService.getReport(config)
          if (response.status === 200) {
            switch (this.report.type) {
              case 1:
                  this.setOptionChart1(response.data)
                  break;
              case 2:
                  this.setOptionChart2(response.data)
                  break;
            }
            this.loading = false
          }
        } catch (err) {
          this.loading = false
        }
      },
    }
  }
</script>
<style scoped>
  >>> .ant-calendar-today .ant-calendar-date {
    color: #9e0207;
    font-weight: bold;
    border-color: #9e0207;
  }

  >>> .b-table {
    font-size: 12px;
  }

  fieldset {
    background-color: #f6f6f6;
    border-radius: 4px;
  }

  legend {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    color: #000;
    font-size: 17px;
    font-weight: bold;
    padding: 3px 5px 3px 7px;
    width: auto;
  }
</style>